module.exports = __webpack_public_path__ + "static/media/holomcts-background.f18a6d52.jpg";